import { action, props } from 'ts-action';
import { SkipHistory } from '../../undo/actions/undo.actions';
import { Strip, StripId } from '../types/strip.type';

export const register = action(
  '[Strip] register - blacklisted',
  props<{ strip: Strip } & SkipHistory>(),
);

export const unregister = action(
  '[Strip] unregister - blacklisted',
  props<{ stripId: StripId } & SkipHistory>(),
);

export const update = action(
  '[Strip] update',
  props<{ stripId: StripId; strip: Partial<Strip> }>(),
);

export const incrementGain = action(
  '[Strip] incrementGain',
  props<{ stripId: StripId; value: 1 | -1 }>(),
);
